import { useState } from "react";
import { PatientCard, Patient } from "./PatientCard";
import { PatientDetailDrawer } from "./PatientDetailDrawer";

export interface Category {
  name: string;
  count: number;
}

interface CategoryColumnProps {
  category: Category;
  patients: Patient[];
}

export const CategoryColumn = ({ category, patients }: CategoryColumnProps) => {
  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const visiblePatients = isExpanded ? patients : patients.slice(0, 5);
  const remainingCount = patients.length - 5;

  const handlePatientClick = (patient: Patient) => {
    setSelectedPatient(patient);
    setIsDrawerOpen(true);
  };

  return (
    <div className="flex-shrink-0 w-[245px]">
      {/* Category Header */}
      <div className="bg-muted/50 rounded-md px-2 py-1.5 flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">{category.name}</span>
        <span className="bg-background rounded-full px-2 py-0.5 text-sm font-medium text-muted-foreground">
          {category.count}
        </span>
      </div>

      {/* Patient Cards Stack */}
      <div className="flex flex-col space-y-2 mt-2">
        {patients.length === 0 ? (
          <div className="text-center py-4 text-muted-foreground text-xs">No patients</div>
        ) : (
          <>
            {visiblePatients.map((patient, index) => (
              <PatientCard
                key={`${patient.id}-${index}`}
                patient={patient}
                onClick={() => handlePatientClick(patient)}
              />
            ))}
            {patients.length > 5 && (
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="text-center py-2 text-xs text-primary hover:text-primary/80 cursor-pointer font-medium transition-colors"
              >
                {isExpanded ? "Show Less" : `+${remainingCount} more`}
              </button>
            )}
          </>
        )}
      </div>

      {/* Patient Detail Drawer */}
      {selectedPatient && (
        <PatientDetailDrawer patient={selectedPatient} open={isDrawerOpen} onOpenChange={setIsDrawerOpen} />
      )}
    </div>
  );
};
